/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S4_P1Inputs */

const en_guide_json_vs_yaml_xml_s4_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML remains essential in enterprise environments, especially for SOAP web services, document formats (HTML, SVG, RSS), and systems that require strict data validation through DTD or XML Schema (XSD).`)
};

const ko_guide_json_vs_yaml_xml_s4_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML은 엔터프라이즈 환경, 특히 SOAP 웹 서비스, 문서 포맷(HTML, SVG, RSS), DTD나 XML Schema(XSD)를 통한 엄격한 데이터 유효성 검사가 필요한 시스템에서 여전히 필수적입니다.`)
};

const ja_guide_json_vs_yaml_xml_s4_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S4_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XMLはエンタープライズ環境、特にSOAP Webサービス、ドキュメント形式（HTML、SVG、RSS）、DTDやXML Schema（XSD）による厳密なデータ検証が必要なシステムで引き続き不可欠です。`)
};

/**
* | output |
* | --- |
* | "XML remains essential in enterprise environments, especially for SOAP web services, document formats (HTML, SVG, RSS), and systems that require strict data v..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_S4_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s4_p1 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S4_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S4_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s4_p1(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s4_p1(inputs)
	return ja_guide_json_vs_yaml_xml_s4_p1(inputs)
});